/**
 * 環境バッジ（03 5.2・FE-D-068）：app_env が dev・mai のとき「開発環境」「保守環境」を出す。prd は出さない。
 * local（開発者の端末）は「ローカル環境」（実装メモ）。
 */
import { Chip } from '@mui/material';
import type { AppEnvName } from '../../app/config/app-config';

const ENV_LABELS: Readonly<Record<AppEnvName, string | null>> = {
  dev: '開発環境',
  mai: '保守環境',
  local: 'ローカル環境',
  prd: null,
};

export function EnvBadge({ app_env }: { app_env: AppEnvName }) {
  const label = ENV_LABELS[app_env];
  if (!label) {
    return null;
  }
  return <Chip label={label} color="warning" size="small" sx={{ ml: 1.5, fontWeight: 500 }} />;
}
